import Vue from 'vue'
import VueI18n from 'vue-i18n'
// const data = require('@locale')
const langData = require('@locale').default

Vue.use(VueI18n)
const messages = langData

// 从sessionStorage读取komoeSeaLang
const parseLangStorage = () => {
    return JSON.parse(window.sessionStorage.getItem('komoeSeaLang'))
}

// 从sessionStorage获取当前语言
const getLang = () => {
    const csLang = parseLangStorage()
    return csLang && csLang.host === window.location.host
        ? csLang.lang
        : process.env.VUE_APP_DEFAULT_LANG
}

const i18n = window.i18n = new VueI18n({
    locale: getLang() || process.env.VUE_APP_DEFAULT_LANG,
    messages
})

export default i18n
